import React from 'react';
import {
  Box,
  Container,
  Heading,
  Stack,
  useToast,
  Flex,
  Spacer
} from '@chakra-ui/react';
import BundleList from '../components/Dashboard/BundleList';
import BundleStats from '../components/Dashboard/BundleStats';

const Dashboard = () => {
  const toast = useToast();

  return (
    <Container maxW="container.xl" py={8}>
      <Stack spacing={8}>
        <Flex align="center">
          <Heading size="lg">Bundle Dashboard</Heading>
          <Spacer />
          <BundleStats />
        </Flex>

        <Box bg="white" rounded="lg" shadow="base" overflow="hidden">
          <BundleList
            onError={(message) => {
              toast({
                title: "Error",
                description: message,
                status: "error",
                duration: 5000,
                isClosable: true,
              });
            }}
          />
        </Box>
      </Stack>
    </Container>
  );
};

export default Dashboard;